module.exports = __webpack_public_path__ + "media/images/nav_icons/ruby-7089b22c1c67a7d44536538121867782.png";